import React, { useState } from "react";

const Description = ({
  heading = "Description",
  text = "No description available",
  limit = 150,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const isLong = text.length > limit;
  const displayText = isExpanded
    ? text
    : text.slice(0, limit) + (isLong ? "..." : "");

  return (
    <div className="w_100">
      <h6>{heading}</h6>
      <p>
        {displayText}{" "}
        {isLong && (
          <span
            style={{ color: "#e71d57", cursor: "pointer" }}
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded ? "Read Less" : "Read More"}
          </span>
        )}
      </p>
    </div>
  );
};

export default Description;
